<template>
  <header class="topbar">
    <!-- Logo -->
    <div class="logo">
      <span class="dot"></span>

      <div>
        <h1>Fascistogramme</h1>
        <p>Analyse automatisée des discours</p>
      </div>
    </div>

    <!-- Bouton hamburger mobile -->
    <button
      class="menu-button"
      :class="{ active: menuOpen }"
      @click="menuOpen = !menuOpen"
      aria-label="Ouvrir le menu"
      :aria-expanded="menuOpen"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- Navigation -->
    <nav
      class="navigation"
      :class="{ open: menuOpen }"
    >
      <RouterLink to="/" @click="menuOpen = false">
        Chatbot
      </RouterLink>

      <RouterLink to="/stat" @click="menuOpen = false">
        Statistiques
      </RouterLink>
    </nav>
  </header>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  components: {
    RouterLink
  },

  data() {
    return {
      menuOpen: false
    };
  }
};
</script>

<style scoped>
/* =========================
   HEADER
========================= */

.topbar {
  background: #111315;
  height: 80px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 50px;

  border-bottom: 1px solid #262626;

  backdrop-filter: blur(15px);

  color: white;

  position: relative;
  z-index: 1000;

  box-sizing: border-box;
}


/* =========================
   LOGO
========================= */

.logo {
  display: flex;
  align-items: center;
  gap: 15px;

  min-width: 0;
}

.dot {
  width: 14px;
  height: 14px;

  flex-shrink: 0;

  border-radius: 50%;

  background: #b91c1c;
}

.logo h1 {
  margin: 0;

  font-size: 28px;

  white-space: nowrap;
}

.logo p {
  margin: 2px 0 0 0;

  color: #999;

  font-size: 14px;

  white-space: nowrap;
}


/* =========================
   NAVIGATION DESKTOP
========================= */

.navigation {
  display: flex;
  align-items: center;

  gap: 35px;
}

.navigation a {
  color: #c9c9c9;

  text-decoration: none;

  transition:
    color 0.25s ease,
    background 0.25s ease;
}

.navigation a:hover {
  color: white;
}


/* =========================
   BOUTON HAMBURGER
========================= */

.menu-button {
  display: none;

  width: 42px;
  height: 42px;

  padding: 8px;

  border: none;
  background: transparent;

  cursor: pointer;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 5px;

  z-index: 1100;
}

.menu-button span {
  display: block;

  width: 25px;
  height: 2px;

  background: white;

  border-radius: 2px;

  transition:
    transform 0.3s ease,
    opacity 0.2s ease;
}


/* =========================
   ANIMATION HAMBURGER → X
========================= */

.menu-button.active span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.menu-button.active span:nth-child(2) {
  opacity: 0;
}

.menu-button.active span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}


/* =========================
   VERSION MOBILE
========================= */

@media (max-width: 768px) {

  .topbar {
    height: 70px;

    padding: 0 20px;
  }

  /* Logo */

  .logo {
    gap: 10px;
  }

  .dot {
    width: 11px;
    height: 11px;
  }

  .logo h1 {
    font-size: 21px;
  }

  .logo p {
    font-size: 11px;
  }


  /* Bouton hamburger */

  .menu-button {
    display: flex;
  }


  /* =========================
     MENU DÉROULANT
  ========================= */

  .navigation {
    position: absolute;

    top: 70px;
    left: 0;
    right: 0;

    width: 100%;

    display: flex;
    flex-direction: column;

    gap: 0;

    background: #111315;

    border-bottom: 1px solid #262626;

    overflow: hidden;

    /* Menu fermé */
    max-height: 0;

    opacity: 0;

    transform: translateY(-10px);

    pointer-events: none;

    transition:
      max-height 0.35s ease,
      opacity 0.25s ease,
      transform 0.35s ease;
  }


  /* Menu ouvert */

  .navigation.open {
    max-height: 200px;

    opacity: 1;

    transform: translateY(0);

    pointer-events: auto;
  }


  /* Liens */

  .navigation a {
    width: 100%;

    box-sizing: border-box;

    padding: 18px 20px;

    border-top: 1px solid #262626;

    color: #c9c9c9;

    background: #111315;

    transition:
      background 0.2s ease,
      color 0.2s ease;
  }

  .navigation a:hover {
    color: white;

    background: #1b1d1f;
  }


  /* Lien actif Vue Router */

  .navigation a.router-link-active {
    color: white;

    background: #1b1d1f;
  }
}


/* =========================
   TRÈS PETITS ÉCRANS
========================= */

@media (max-width: 400px) {

  .topbar {
    padding: 0 15px;
  }

  .logo h1 {
    font-size: 18px;
  }

  .logo p {
    font-size: 10px;
  }

  .menu-button {
    width: 38px;
    height: 38px;
  }
}
</style>
